export const getQueryString = (params) => {
    const queryParams = [];
    Object.entries(params).forEach(([key, value]) => {
        if (key === "url") {
            return;
        }
        queryParams.push(`${key}=${encodeURIComponent(value)}`);
    });
    return queryParams.length > 0 ? queryParams.join("&") : "";
};
export const getQueryParameter = (name, url = window.top.location.href) => {
    name = name.replace(/[[\]]/g, "\\$&");
    const regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"), results = regex.exec(url);
    if (!Array.isArray(results)) {
        return null;
    }
    if (typeof results[2] !== "string") {
        return "";
    }
    return decodeURIComponent(results[2].replace(/\+/g, " "));
};
export const getRandomString = (size = 45) => {
    const unreserved = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let randomString = "";
    const crypto = window.crypto;
    if (crypto) {
        const bytes = new Uint8Array(size);
        crypto.getRandomValues(bytes);
        const numbers = [];
        bytes.forEach((x, i) => {
            numbers[i] = unreserved.charCodeAt(x % unreserved.length);
        });
        randomString = String.fromCharCode.apply(null, numbers);
    }
    else {
        while (0 < size--) {
            randomString +=
                // eslint-disable-next-line no-bitwise
                unreserved[Math.floor(Math.random() * unreserved.length) | 0];
        }
    }
    return randomString;
};
const strToBuffer = (str) => {
    const arrayBuffer = new ArrayBuffer(str.length);
    const uintArray = new Uint8Array(arrayBuffer);
    uintArray.forEach((_, i) => {
        uintArray[i] = str.charCodeAt(i);
    });
    return uintArray;
};
/* eslint-disable-next-line @typescript-eslint/no-explicit-any */
export const base64UrlEncode = (str) => {
    return window.btoa(str).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
};
export const getCodeVerifier = () => {
    return base64UrlEncode(getRandomString(43));
};
export const getCodeChallenge = async (codeVerifier) => {
    try {
        const digest = await crypto.subtle.digest("SHA-256", strToBuffer(codeVerifier));
        const digestBase64 = String.fromCharCode(...Array.from(new Uint8Array(digest)));
        return base64UrlEncode(digestBase64);
    }
    catch (_a) {
        return codeVerifier;
    }
};
export const getUrlOrigin = (url) => {
    const regex = new RegExp("^(https?:\\/\\/[^\\/?]+)");
    const results = regex.exec(url);
    if (!Array.isArray(results)) {
        return "";
    }
    return results[1];
};
const CHECK_SESSION_IFRAME_TPL = `
<script type="text/javascript">
    /** @type {HTMLIFrameElement} */
    var opIframe = document.createElement("iframe");

    /** @type {number} */
    var pollIntervalDelay = 2000;

    /** @type {number} */
    var pollInterval;

    /**
     * Send poll message to OP iframe
     */
    function poll () {
        try {
            opIframe.contentWindow.postMessage("{CLIENT_ID} {SESSION_STATE}", "{OP_ORIGIN}");
        } catch (e) {
            console.error(e);
            window.clearInterval(pollInterval);
        }
    }

    /**
     * Pass OP iframe message up to host
     * @param event {MessageEvent}
     */
    function receiveMessage(event) {
        window.parent.postMessage([event.data, "{SESSION_STATE}"].join(" "), "{ORIGIN}");
    }

    window.onload = function() {
        opIframe.src = "{OP_SRC}";
        document.body.appendChild(opIframe);
        window.addEventListener("message", receiveMessage);
        pollInterval = window.setInterval(poll, pollIntervalDelay);
    }
</script>
`;
export const getCheckSessionIframeSrcdoc = ({ session_state, client_id, op_src }) => {
    return CHECK_SESSION_IFRAME_TPL.replace(/{CLIENT_ID}/g, client_id)
        .replace(/{SESSION_STATE}/g, session_state)
        .replace(/{OP_ORIGIN}/g, getUrlOrigin(op_src))
        .replace(/{OP_SRC}/g, op_src)
        .replace(/{ORIGIN}/g, window.origin);
};
/**
 * Decodes the payload of a JWT id_token.
 *
 * @param token - The JWT string
 * @returns The decoded payload as an object
 * @throws Error if the token is invalid or cannot be decoded
 */
export function extractJwtPayload(token) {
    if (!token) {
        throw new Error("Token is required");
    }
    const parts = token.split(".");
    if (parts.length !== 3) {
        throw new Error("Invalid JWT token format");
    }
    const payload = parts[1];
    try {
        // Decode Base64Url to JSON string
        const decodedPayload = decodeBase64Url(payload);
        return JSON.parse(decodedPayload);
    }
    catch (error) {
        throw new Error("Failed to decode JWT payload: " + error.message);
    }
}
/**
 * Decodes a Base64Url encoded string.
 *
 * @param base64Url - The Base64Url encoded string
 * @returns The decoded string
 */
function decodeBase64Url(base64Url) {
    // Replace URL-safe characters and pad with '='
    let base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    // Add padding if necessary
    while (base64.length % 4) {
        base64 += "=";
    }
    // Decode Base64 string using atob (browser-safe)
    return decodeURIComponent(Array.prototype.map
        .call(atob(base64), (c) => {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    })
        .join(""));
}
//# sourceMappingURL=silent-auth-utils.js.map
